import type { KemMessage } from "@ch/generated";
import type { KemCitationResource } from "./types";

type KemCitationSourceMessage = Pick<KemMessage, "citations" | "resources">;

const isNonEmptyString = (value: unknown): value is string =>
  typeof value === "string" && value.trim() !== "";

const parseCitationEntry = (entry: unknown): KemCitationResource | null => {
  if (!entry || typeof entry !== "object") {
    return null;
  }

  const { value, label, url } = entry as Record<string, unknown>;

  if (
    !isNonEmptyString(value) ||
    !isNonEmptyString(label) ||
    !isNonEmptyString(url)
  ) {
    return null;
  }

  return {
    value: value.trim(),
    label: label.trim(),
    url: url.trim(),
  };
};

export const pickKemCitationSource = (
  message: KemCitationSourceMessage,
): KemCitationSourceMessage["citations"] =>
  message.citations?.length ? message.citations : message.resources;

export const parseKemCitationResources = (
  raw: unknown,
): KemCitationResource[] => {
  if (!Array.isArray(raw)) {
    return [];
  }

  return raw
    .map(parseCitationEntry)
    .filter((entry): entry is KemCitationResource => entry !== null);
};
